import OverlayTrigger from './OverlayTrigger';

export { OverlayTrigger };
export default OverlayTrigger;
